module.exports = __webpack_public_path__ + "img/achievement_18.ae1660f4.png";